function longAddressHandler(text){
    let firstFour = text.substring(0,6); 
    let lastFour = text.substr(text.length - 4);

    return firstFour+'....'+lastFour;
}
export default longAddressHandler;